import type { Currency } from '@/api/models';

export const DEFAULT_CURRENCY: Currency = {
  code: 'EUR', symbol: '€', minorUnit: 0, decimalSeparator: ',', thousandSeparator: '.', prefix: '', suffix: ' €',
};

/** Format an amount in minor units using the store's own currency settings from WooCommerce. */
export function formatMoney(minor: number, c: Currency = DEFAULT_CURRENCY): string {
  const value = minor / Math.pow(10, c.minorUnit);
  const [int, dec] = Math.abs(value).toFixed(c.minorUnit).split('.');
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, c.thousandSeparator);
  const num = dec ? grouped + c.decimalSeparator + dec : grouped;
  return (value < 0 ? '−' : '') + c.prefix + num + c.suffix;
}

/** Parse a Store API amount string (already in minor units). */
export const toMinor = (s: string | number | null | undefined) =>
  s === null || s === undefined || s === '' ? 0 : parseInt(String(s), 10) || 0;
